import React, { useEffect, useState } from "react";
import FinancialReportBaseComponentHeader from "./CommonComponentOfFinancialReportFolder/FinancialReportBaseComponentHeader.jsx";

import useApi from "../hooks/useApiGetPost";
import BalanceSheetGroup from "./BalanceSheetModeComponentFolder/BalanceSheetGroup.jsx";
import BalanceSheetDetailed from "./BalanceSheetModeComponentFolder/BalanceSheetDetailed.jsx";
import BalanceSheetGroupPDF from "./pdf_for_report/BalanceSheetPDFFolder/BalanceSheetGroupPDF.js";
import BalanceSheetDetailedPDF from "./pdf_for_report/BalanceSheetPDFFolder/BalanceSheetDetailedPDF.js";


function BalanceSheetReport() {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const [cleanedData, setCleanedData] = useState(null);
  // Define which columns are critical
  const requiredColumns = ["DEBIT", "CREDIT"];


  const { data: datagetgetFinancialDateApi, get: getFinancialDateApi } =
  useApi();

  const modeComponentMap = {
    BSGROUP: BalanceSheetGroup,
    BSACC: BalanceSheetDetailed,

    // add more modes and components here
  };

  const pdfComponentMap = {
    BSGROUP: BalanceSheetGroupPDF,
    BSACC: BalanceSheetDetailedPDF,
  };

  const {
    data: datagetTrialBalanceReport,
    loading: loadinggetTrialBalanceReport,
    error: errorgetTrialBalanceReport,
    get: getTrialBalanceReport,
  } = useApi();

  const today = new Date();
  const formatted = today.toISOString().split("T")[0];

  let mode_list = [
    {
      mode_name: "Balance Sheet (Group)",
      mode_code: "BSGROUP",
      is_selected: true,
    },
    {
      mode_name: "Balance Sheet Detailed",
      mode_code: "BSACC",
      is_selected: false,
    },
  ];

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  let local_department_list_array = currentUser.map((item) => ({
    ...item,
    department_name: item.DEPTNO,
    department_code: item.DEPTNO,
    is_selected: false,
  }));

  let department_list = [
    { department_name: "ALL", department_code: "ALL", is_selected: true },
    ...local_department_list_array,
  ];

  let checkbox_list = [
    {
      checkbox_name: "Include Zero Balance",
      checkbox_code: "Include_Zero_Balance",
      is_selected: false,
    },
    {
      checkbox_name: "Activate From Date For Movement",
      checkbox_code: "Activate_From_Date_For_Movement",
      is_selected: false,
    },
  ];

  let toggle_list = [
    {
      toggle_name: "Include Stock",
      toggle_code: "Include_Stock",
      is_selected: false,
    },
    {
      toggle_name: "Plus Qty Only",
      toggle_code: "Plus_Qty_Only",
      is_selected: false,
    },
  ];

  let parentInitialObject = {
    report_name: "Balance Sheet",
    from_date: formatted,
    to_date: formatted,
    mode_list_array: mode_list,
    department_list_array: department_list,
    checkbox_list_array: checkbox_list,
    toggle_button_list_array: toggle_list,
  };

  const [parentDetails, setParentDetails] = useState(parentInitialObject);
  const [selectedMode, setSelectedMode] = useState(
    parentInitialObject.mode_list_array?.filter(
      (itemFilly) => itemFilly.is_selected,
    )[0].mode_code,
  );

  // useEffect(() => {

  //     console.log("parentDetails updated", parentDetails)

  //     if (parentDetails.mode_list_array) {
  //         let newMode = parentDetails.mode_list_array.filter((itemFilly) => itemFilly.is_selected)[0].mode_code
  //         setSelectedMode(newMode)
  //     }

  // }, [parentDetails.mode_list_array])

  useEffect(() => {
    console.log("parentDetails updated", parentDetails);

    if (parentDetails) {
      callAPIToGetTrialBalance();
    }
  }, [parentDetails]);

  // const callAPIToGetTrialBalance = (selectedModeForAPI) => {

  //     let from_date_to_pass_in_api = parentDetails.from_date
  //     let to_date_to_pass_in_api = parentDetails.to_date
  //     let zero = parentDetails.checkbox_list_array.filter((item) => item.checkbox_name === "Include Zero Balance")[0]?.is_selected ? "y" : "-"
  //     let include_stock = parentDetails.toggle_button_list_array.filter((item) => item.toggle_name === "Include Stock")[0]?.is_selected ? "y" : "-"
  //     let plus_qty = parentDetails.toggle_button_list_array.filter((item) => item.toggle_name === "Plus Qty Only")[0]?.is_selected ? "y" : "-"
  //     let selected_department = "ALL"
  //     let period = "-"
  //     let apiURL = `${API_PATHS[0].API_CONFIG}/api/CRMBalanceSheet/${COMPANY_CODE}/${selectedModeForAPI}/${from_date_to_pass_in_api}/${to_date_to_pass_in_api}/${zero}/${period}/${selected_department}/${include_stock}/${plus_qty}`

  //     console.log("apiURL-->++ mode_list", apiURL)
  //     getTrialBalanceReport(apiURL)

  // }

  const callAPIToGetTrialBalance = () => {
    let from_date_to_pass_in_api = parentDetails.from_date;
    let to_date_to_pass_in_api = parentDetails.to_date;
    let zero = parentDetails.checkbox_list_array.filter(
      (item) => item.checkbox_name === "Include Zero Balance",
    )[0]?.is_selected
      ? "y"
      : "-";
    let include_stock = parentDetails.toggle_button_list_array.filter(
      (item) => item.toggle_name === "Include Stock",
    )[0]?.is_selected
      ? "y"
      : "-";
    let plus_qty = parentDetails.toggle_button_list_array.filter(
      (item) => item.toggle_name === "Plus Qty Only",
    )[0]?.is_selected
      ? "y"
      : "-";
    let selected_department = "ALL";
    let period = "-";
    let selectedMode = parentDetails.mode_list_array.filter(
      (itemFilly) => itemFilly.is_selected,
    )[0].mode_code;
    let apiURL = `${API_PATHS[0].API_CONFIG}/api/CRMBalanceSheet/${COMPANY_CODE}/${selectedMode}/${from_date_to_pass_in_api}/${to_date_to_pass_in_api}/${zero}/${period}/${selected_department}/${include_stock}/${plus_qty}`;

    console.log("apiURL-->++ mode_list", apiURL);
    getTrialBalanceReport(apiURL);
  };

  let selected_mode_table_structure = [
    {
      mode_table_name: "Balance Sheet (Group)",
      mode_table_code: "BSGROUP",
      mode_table_columns: [
        {
          column_name: "NODE",
          column_key_from_api: "NODE",
        },
        {
          column_name: "GROUP CODE",
          column_key_from_api: "GROUP CODE",
        },
        {
          column_name: "DEBIT",
          column_key_from_api: "DEBIT",
        },
        {
          column_name: "CREDIT",
          column_key_from_api: "CREDIT",
        },
      ],
    },
    {
      mode_table_name: "Balance Sheet Detailed",
      mode_table_code: "BSACC",
      mode_table_columns: [
        {
          column_name: "NODE",
          column_key_from_api: "NODE",
        },
        {
          column_name: "GROUP CODE",
          column_key_from_api: "GROUP CODE",
        },
        {
          column_name: "ACCOUNT",
          column_key_from_api: "ACCOUNT",
        },
        {
          column_name: "DESCRIPTION",
          column_key_from_api: "DESCRIPTION",
        },
        {
          column_name: "DEBIT",
          column_key_from_api: "DEBIT",
        },
        {
          column_name: "CREDIT",
          column_key_from_api: "CREDIT",
        },
        {
          column_name: "BALANCE",
          column_key_from_api: "BALANCE",
        },
      ],
    },
  ];

  // useEffect(() => {
  //     callAPIToGetTrialBalance(selectedMode);
  // }, [selectedMode]);

  const ModeComponent =
    modeComponentMap[
      parentDetails.mode_list_array?.find((item) => item.is_selected)?.mode_code
    ];
  const PDFComponent =
    pdfComponentMap[
      parentDetails.mode_list_array?.find((item) => item.is_selected)?.mode_code
    ];

  useEffect(() => {
    if (datagetTrialBalanceReport) {
      // Filter data
      const cleanedData = datagetTrialBalanceReport?.filter((row) =>
        requiredColumns.every(
          (col) => row[col] !== null && row[col] !== undefined,
        ),
      );
      setCleanedData(cleanedData);
    }
  }, [datagetTrialBalanceReport]);


  useEffect(() => {
    getFinancialDateApi(
      `${API_PATHS[0].API_CONFIG}/api/Cpayscount/${COMPANY_CODE}/companyinfo/-/-`,
    );
  }, []);


  useEffect(() => {
    if (datagetgetFinancialDateApi && datagetgetFinancialDateApi[0]?.fystart) {
      const fyStartDate = datagetgetFinancialDateApi[0].fystart.split("T")[0];
      
      setParentDetails((prev) => ({
        ...prev,
        from_date: fyStartDate,
      }));
    }
  }, [datagetgetFinancialDateApi]);

  return (
    <div>
      <div className="p-2">
        <FinancialReportBaseComponentHeader
          selectedMode={selectedMode}
          parentDetails={parentDetails}
          setParentDetails={setParentDetails}
          PDFComponent={PDFComponent || null}
          datagetTrialBalanceReport={cleanedData}
          selected_mode_table_structure={selected_mode_table_structure}
          datagetgetFinancialDateApi = {datagetgetFinancialDateApi}
        />

        {cleanedData && ModeComponent && (
          <ModeComponent
            key={selectedMode}
            datagetTrialBalanceReport={cleanedData}
            parentDetails={parentDetails}
            selected_mode_table_structure={selected_mode_table_structure}
          />
        )}
      </div>
    </div>
  );
}

export default BalanceSheetReport;
